import { useNavigate } from "react-router-dom"
import "./RequirementCard.scss"
import React from 'react'
import { formatToIndianRupees } from "../../../lib/allPurposeFunctions";
// import Card from './../../../components/card/Card';







const RequirementCard = ({
  RequirementItem,
  RequirementId,
  userId,
  onNavigateRequirementView,
}) => {
  let {
    dateofrequirement,
    requirementdate,
    requirementdetails,
    colonies,
    propertytags,
    propertytypes,
    transactiontypes,
    budgetfrom,
    budgetto,

    id,
  } = RequirementItem;

  const navigate = useNavigate();

  //   console.log("Requirement Card: ",RequirementItem)

  function normalizeArray(value) {
    if (Array.isArray(value)) return value;

    if (typeof value === "string") {
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }

    return [];
  }

  //    colonies = Array.isArray(colonies) ? colonies : [];

  // colonies = (() => {
  // if (Array.isArray(colonies)) return colonies;
  // if (typeof colonies === "string") {
  //     try { return JSON.parse(colonies); } catch { return []; }
  // }
  // return [];
  // })();

  //    propertytags = Array.isArray(propertytags) ? propertytags : [];
  //    propertytypes = Array.isArray(propertytypes) ? propertytypes : [];
  //    transactiontypes = Array.isArray(transactiontypes) ? transactiontypes : [];

  colonies = normalizeArray(colonies);
  propertytags = normalizeArray(propertytags);
  propertytypes = normalizeArray(propertytypes);
  transactiontypes = normalizeArray(transactiontypes);

  const colonystr = colonies.map((c) => c.colonyname).join(", ");
  const propertytagsstr = propertytags.map((p) => p.tagname).join(", ");
  const propertytypesstr = propertytypes
    .map((pt) => pt.propertytype)
    .join(", ");
  const transactiontypesstr = transactiontypes
    .map((t) => t.transactiontype)
    .join(", ");

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent the click from propagating to the card

    //   navigate(`/requirements/${id}`);

    //  alert("ss")
    try {
      if (onNavigateRequirementView) {
        // console.log("navigating from parent");
        onNavigateRequirementView(RequirementItem);
      } else {
        console.log("navagating from child itself");
        navigate("/dashboard/saverequirement/", {
          state: {
            mode: 1,
            requirementObject: RequirementItem,
            requirementId: RequirementId,
            userId: userId,
          },
        });
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="requirementCard" onClick={handleClick}>
        <div className="reqRow">
          <div className="reqCol1">
            <div className="requirementDate">
              <h3>{dateofrequirement}</h3>
            </div>
          </div>
        </div>
        <div className="reqRow">
          <div className="reqCol1">Details:</div>
          <div className="reqCol2">{requirementdetails}</div>
        </div>

        <div className="reqRow">
          <div className="reqCol1">Transaction Types:</div>

          <div className="reqCol2">{transactiontypesstr}</div>
        </div>
        <div className="reqRow">
          <div className="reqCol1">Property Types:</div>

          <div className="reqCol2">{propertytypesstr}</div>
        </div>

        <div className="reqRow">
          <div className="reqCol1">Colony Interests Types:</div>

          <div className="reqCol2">{colonystr}</div>
        </div>

        <div className="reqRow">
          <div className="reqCol1">Tags:</div>

          <div className="reqCol2">{propertytagsstr}</div>
        </div>

        <div className="reqRow">
          <div className="reqCol1">Budget</div>

          <div className="reqCol2">
            From: {formatToIndianRupees(budgetfrom)} <strong> - </strong>{" "}
            {formatToIndianRupees(budgetto)}
          </div>
        </div>
      </div>
    </>
  );
};

export default RequirementCard
